import { find, keyBy } from 'lodash';
import { levels } from '@prolaera/library';

export default function($log, $q, $stateParams, ApiClass, ProfileClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  vm.profile_uid = $stateParams.id;

  const { company_id } = ProfileClass.profileComplete.profile;

  vm.timeOptions = {
    hstep: 1,
    mstep: 1,
    ismeridian: true,
    today: new Date()
  };

  vm.startDateOptions = {
    opened: false,
    openCalendar: () => {
      vm.startDateOptions.opened = true;
    }
  };

  vm.endDateOptions = {
    opened: false,
    openCalendar: () => {
      vm.endDateOptions.opened = true;
    }
  };

  vm.changeSponsor = (sponsor_id, sponsors) => {
    const sponsor = find(sponsors, { sponsor_id });
    vm.event.sponsor = sponsor;
  };

  vm.uploadedProductImage = link => {
    vm.event.productImageUrl = link;
  };

  function activate() {
    $log.debug('Edit Event Overview Component Activated');
    const promiseArray = [
      ApiClass.companiesIdGet({ manage: true, id: company_id }, null, {
        queryParams: {
          payees: true,
          vendors: true,
          evaluationForms: true,
          sponsors: true
        }
      })
    ];

    $q.all(promiseArray)
      .then(([{ data: { evaluationForms, sponsors, payees, vendors } }]) => {
        vm.sponsors = sponsors.filter(({ archived }) => !archived);

        if (vm.event && vm.event.sponsor) vm.event.sponsor_id = vm.event.sponsor.sponsor_id;
        else vm.event.sponsor = undefined;

        vm.levels = levels;
        vm.reviewForms = keyBy(evaluationForms, 'form_id');
        vm.vendors = vendors;
        vm.payees = payees;
        vm.loaded = true;
      })
      .catch(error => {
        $log.error(error);
        vm.loaded = true;
        vm.error = false;
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/eventManager/event/eventOverviewEditor/controller.js